import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getMessageAccueil() {
    const message = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_MESSAGE_ACCUEIL
    );

    return message.data;
  },
  async setMessageAccueil(message) {
    var config = {
      headers: {
        "Content-Type": "text/plain",
        //'Content-Length': message.length
      },
      responseType: "text",
    };
    const demande = await axios.put(
      process.env.VUE_APP_BACKEND_API_URL + "/api/admin/refmessage/accueil",
      message,
      config
    );

    return demande.data;
  },
  async getMessageAccueilDRH() {
    const message = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_MESSAGE_ACCUEIL_DRH
    );

    return message.data;
  },
  async setMessageAccueilDRH(message) {
    var config = {
      headers: {
        "Content-Type": "text/plain",
        //'Content-Length': message.length
      },
      responseType: "text",
    };
    const demande = await axios.put(
      process.env.VUE_APP_BACKEND_API_URL + "/api/admin/refmessage/accueilDRH",
      message,
      config
    );

    return demande.data;
  },
  async getMessageInformation() {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_MESSAGE_INFORMATION
      )
    ).data;
  },

  async getDRHMessageInformationDepotPiece() {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_MESSAGE_INFORMATION_DRH_DEPOT_PIECE
      )
    ).data;
  },
  async setMessageInformation(message) {
    var config = {
      headers: {
        "Content-Type": "text/plain",
        //'Content-Length': message.length
      },
      responseType: "text",
    };
    const demande = await axios.put(
      process.env.VUE_APP_BACKEND_API_URL + "/api/admin/refmessage/information",
      message,
      config
    );

    return demande.data;
  },

  async getBySearch(nom) {
    if (nom) {
      return (
        await axios.get(
          process.env.VUE_APP_BACKEND_API_URL +
            process.env.VUE_APP_URL_MESSAGE +
            nom
        )
      ).data;
    }
  },

  async getByType(type) {
    if (type) {
      return (
        await axios.get(
          process.env.VUE_APP_BACKEND_API_URL +
            process.env.VUE_APP_URL_MESSAGE_TYPE +
            type
        )
      ).data;
    }
  },

  async setMessage(message) {
    return (
      await axios.put(
        process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_MESSAGE,
        message
      )
    ).data;
  },
};
